import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";

const LINKS = [
  { label: "Packages", href: "#packages" },
  { label: "Results", href: "#results" },
  { label: "Process", href: "#process" },
  { label: "FAQ", href: "#faq" },
];

export default function Header({ onBook }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 border-b ${
        scrolled
          ? "bg-black/70 backdrop-blur-2xl border-white/10"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-baseline gap-2 group">
          <span className="font-syne font-extrabold text-2xl tracking-tight text-white group-hover:text-amber-400 transition-colors duration-300">
            P&H
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-400 hidden sm:inline">
            Mobile Detailing
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400 hover:text-amber-400 transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:9197373526"
            data-testid="header-call-button"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-amber-500 hover:bg-amber-400 text-black font-semibold text-sm px-5 py-2.5 transition-colors duration-300"
          >
            <Phone size={15} strokeWidth={2.5} />
            919-737-3526
          </a>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden text-slate-200 p-2"
            aria-label="Toggle menu"
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-black/95 backdrop-blur-2xl border-t border-white/10 px-6 py-6 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              onClick={() => setMenuOpen(false)}
              className="font-syne font-bold text-lg uppercase text-slate-200 hover:text-amber-400 transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="tel:9197373526"
            data-testid="mobile-call-button"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-amber-500 text-black font-semibold px-5 py-3 mt-2"
          >
            <Phone size={16} /> Call 919-737-3526
          </a>
        </div>
      )}
    </header>
  );
}
